"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GreenMarsInitiative = void 0;
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const CardRenderer_1 = require("../../render/CardRenderer");
const Turmoil_1 = require("../../../turmoil/Turmoil");
const PartyName_1 = require("../../../turmoil/parties/PartyName");
const Resources_1 = require("../../../Resources");
const Card_1 = require("../../Card");
const Tags_1 = require("../../Tags");
const PlaceGreeneryTile_1 = require("../../../deferredActions/PlaceGreeneryTile");
class GreenMarsInitiative extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.GREEN_MARS_INITIATIVE,
            tags: [Tags_1.Tags.PLANT],
            metadata: {
                cardNumber: 'Y41',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.delegates(2).greens();
                    b.greenery();
                }),
                description: 'Place 2 delegates into Greens and place a greenery tile.',
            },
        });
    }
    canPlay(player) {
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        const party = turmoil.parties.find((p) => p.name === PartyName_1.PartyName.GREENS);
        if (party === undefined)
            Card_1.Card.setSocietyWarningText(this, PartyName_1.PartyName.GREENS);
        return true;
    }
    play(player) {
        const game = player.game;
        const turmoil = Turmoil_1.Turmoil.getTurmoil(game);
        if (turmoil.parties.find((p) => p.name === PartyName_1.PartyName.GREENS)) {
            turmoil.sendDelegateToParty(player.id, PartyName_1.PartyName.GREENS, game, 'reserve');
            turmoil.sendDelegateToParty(player.id, PartyName_1.PartyName.GREENS, game, 'reserve');
        }
        else {
            player.addResource(Resources_1.Resources.MEGACREDITS, 7, { log: true });
        }
        game.defer(new PlaceGreeneryTile_1.PlaceGreeneryTile(player));
        return undefined;
    }
}
exports.GreenMarsInitiative = GreenMarsInitiative;
//# sourceMappingURL=GreenMarsInitiative.js.map